import styled from 'styled-components';

export const ChannelCellStyled = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;

  svg {
    height: 20px;
    width: 20px;

    &:not(.is-active) {
      filter: grayscale(100%);
    }
  }

  .tooltip-container {
    line-height: 1rem;
  }
`;
